"use client";

import { useEffect, useRef, useState } from "react";

type PointsBarProps = {
  level?: number;
  totalPoints?: number;
  pointsIntoCurrentLevel?: number;
  pointsSpanToNextLevel?: number;
  pointsToNextLevel?: number | null;
};

export function PointsBar({
  level = 0,
  totalPoints = 0,
  pointsIntoCurrentLevel = 0,
  pointsSpanToNextLevel = 1,
  pointsToNextLevel = null,
}: PointsBarProps) {
  const [pointsGain, setPointsGain] = useState<number | null>(null);
  const previousTotal = useRef(totalPoints);
  const safeSpan = pointsSpanToNextLevel > 0 ? pointsSpanToNextLevel : 1;
  const progress = pointsToNextLevel === null ? 100 : Math.min(100, Math.max(0, (pointsIntoCurrentLevel / safeSpan) * 100));

  useEffect(() => {
    const gain = totalPoints - previousTotal.current;
    previousTotal.current = totalPoints;

    if (gain <= 0) return;

    setPointsGain(gain);
    const timer = setTimeout(() => setPointsGain(null), 1200);
    return () => clearTimeout(timer);
  }, [totalPoints]);

  return (
    <div className="min-w-[260px] select-none">
      <div className="flex items-center justify-between gap-2 text-xs font-semibold text-[#3f544d]">
        <p className="whitespace-nowrap">
          Level {level} - {totalPoints} Points
        </p>
        {pointsGain ? <span className="text-[#0f766e]">+{pointsGain} Points</span> : null}
      </div>
      <div className="mt-2 h-3 w-full overflow-hidden rounded-full bg-[#e8ddc9]">
        <div
          className="h-full rounded-full bg-[#0f766e] transition-[width] duration-500 ease-out"
          style={{ width: `${progress}%` }}
        />
      </div>
      <p className="mt-1 text-[11px] text-[#647770]">
        {pointsToNextLevel === null ? "Max level reached" : `${pointsToNextLevel} points to next level`}
      </p>
    </div>
  );
}
